/*
 * @Author: your name
 * @Date: 2018-08-03 14:02:22
 * @LastEditTime: 2021-08-02 17:52:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/constants/talent.js
 */
/**
 * ==== 人才库
 */
// 开始请求人才列表数据
export const LOAD_LIST_START = "LOAD_LIST_START";
// 请求人才列表数据结束
export const LOAD_LIST_DONE = "LOAD_LIST_DONE";
export const LOAD_TALENT_LIST = "LOAD_TALENT_LIST";

// ==== 人才库分类 ====
export const LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
export const LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
export const LOAD_TALENT_CATEGORY = "LOAD_TALENT_CATEGORY";

// ==== 推荐职位 ====
export const RECOMMEND_POSITION_START = "RECOMMEND_POSITION_START";
export const RECOMMEND_POSITION_DONE = "RECOMMEND_POSITION_DONE";

// ==== 创建分类 ====
export const SHOW_CREATE_LABEL_MODAL = "SHOW_CREATE_LABEL_MODAL";
export const HIDE_CREATE_LABEL_MODAL = "HIDE_CREATE_LABEL_MODAL";
export const CREATE_LABEL_START = "CREATE_LABEL_START";
export const CREATE_LABEL_DONE = "CREATE_LABEL_DONE";
export const SHOW_DELETE_LABEL_MODAL = "SHOW_DELETE_LABEL_MODAL";
export const HIDE_DELETE_LABEL_MODAL = "HIDE_DELETE_LABEL_MODAL";
export const DELETE_LABEL_START = "DELETE_LABEL_START";
export const DELETE_LABEL_DONE = "DELETE_LABEL_DONE";

// ==== 移动简历 ====
export const SHOW_MOVE_RESUME_MODAL = "SHOW_MOVE_RESUME_MODAL";
export const HIDE_MOVE_RESUME_MODAL = "HIDE_MOVE_RESUME_MODAL";
export const MOVE_RESUME_START = "MOVE_RESUME_START";
export const MOVE_RESUME_DONE = "MOVE_RESUME_DONE";

// ==== 人才单个导入的组件 ====
export const TALENT_SOLE_MODEL_START = "TALENT_SOLE_MODEL_START";
export const TALENT_SOLE_MODEL_DONE = "TALENT_SOLE_MODEL_DONE";
export const TALENT_SOLE_START = "TALENT_SOLE_START";
export const TALENT_SOLE_DONE = "TALENT_SOLE_DONE";



// WEBPACK FOOTER //
// ./src/constants/talent.js